import { render, staticRenderFns } from "./post-zufang.vue?vue&type=template&id=c2897566&scoped=true&"
import script from "./post-zufang.vue?vue&type=script&lang=js&"
export * from "./post-zufang.vue?vue&type=script&lang=js&"
import style0 from "./post-zufang.vue?vue&type=style&index=0&id=c2897566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2897566",
  null
  
)

export default component.exports